// extracted by mini-css-extract-plugin
export default {"link":"OpI344","message":"X4CtoM","list":"Cq0VZn","text":"aGzdKZ","item":"CWn4IW"};